<template>
  <div>
    <!-- header -->
    <Header></Header>

    <!-- intro -->
    <Intro></Intro>

    <!-- core value & identity -->
    <Identity></Identity>

    <!-- carrot 기업문화 -->
    <Culture></Culture>

    <!-- ceo -->
    <Ceo></Ceo>

    <!-- articles -->
    <Articles></Articles>

    <!-- 인재채용 -->
    <Recruitment></Recruitment>

    <!-- 오시는 길 -->
    <Map></Map>

    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import { onMounted } from "vue";
import Header from "@/components/NewGlobal/Introduce/Header.vue";
import Intro from "@/components/NewGlobal/Introduce/Main/Intro.vue";
import Identity from "@/components/NewGlobal/Introduce/Main/Identity.vue";
import Culture from "@/components/NewGlobal/Introduce/Main/Culture.vue";
import Ceo from "@/components/NewGlobal/Main/Ceo.vue";
import Articles from "@/components/NewGlobal/Introduce/Main/Articles.vue";
import Recruitment from "@/components/NewGlobal/Introduce/Main/Recruitment.vue";
import Map from "@/components/NewGlobal/Introduce/Main/Map.vue";
import Footer from "@/components/NewGlobal/Footer.vue";
import "@/assets/style/newGlobalReset.scss";

export default {
  name: "Main",
  components: {
    Header,
    Intro,
    Identity,
    Culture,
    Ceo,
    Articles,
    Recruitment,
    Map,
    Footer,
  },
  setup() {
    onMounted(() => {
      // const header = document.getElementById("header");
      // header.style.display = "none";
    });
  },
};
</script>

<style lang="scss" scoped></style>
